const SellRefPayInvoice = () => {
    return (
        <>
            <div className=' display-max'>
                <section className="invoice-page">
                    <header className="top">
                        <div className="invoice-title">
                            <div>
                                <img src="../../assets/img/salarlogo.png" className='invoice-logo' alt="" />
                            </div>
                            <strong className=' text-black'>Seller Referral Incentive Payouts</strong>
                            <span className=' text-sm text-black'>(Original for Recipient)</span>
                        </div>
                    </header>
                    <div className="order-grid">
                        <div className=' text-black'>
                            <div className=' text-black'><b>Date :</b>08/07/2026</div>
                            <div className=' text-black'><b>Payout Date :</b>08/07/2026</div>
                        </div>
                        <div className="right">
                            <div className=' text-black'><b>Payout Referral ID :</b>#2323232</div>
                            <div className=' text-black'><b>Transaction ID :</b>50016520039858</div>
                        </div>
                    </div>
                    <div className="address-grid-2">
                        <div className="seller">
                            <div className="seller-meta">
                                <h3 className=' text-black'>Seller Details :</h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1">
                                    <div className=' text-black col-3'><b>Referral ID:</b></div>
                                    <div className=' text-black col-9'>SNM12345GF</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Name:</b></div>
                                    <div className=' text-black col-9'>M SIDDHARTH</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>S/o:</b></div>
                                    <div className=' text-black col-9'>M SRINIVASULU</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Age:</b></div>
                                    <div className=' text-black col-9'>29 Years</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>DOB:</b></div>
                                    <div className=' text-black col-9'>30/Sept/1996</div>
                                </div>
                            </div>
                            <div className="seller-meta mt-2">
                                <h3 className=' text-black'>Kyc Details : <b className=" text-success">Approved</b></h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1">
                                    <div className=' text-black col-3'><b>Aadhaar No:</b></div>
                                    <div className=' text-black col-9'>54631235645765</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Pan No:</b></div>
                                    <div className=' text-black col-9'>ABECS3478</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Voter ID:</b></div>
                                    <div className=' text-black col-9'>APLI34565434</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Passport:</b></div>
                                    <div className=' text-black col-9'>J8369854</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Driving License:</b></div>
                                    <div className=' text-black col-9'>DL-AN5565759955656</div>
                                </div>
                            </div>
                        </div>
                        <div className="addresses right">
                            <div className="address-block">
                                <h3 className=' text-black'>Bank Details :</h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Country:</b></div>
                                    <div className=' text-black col-3'>India</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Bank Name:</b></div>
                                    <div className=' text-black col-3'>HDFC Bank</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Account No:</b></div>
                                    <div className=' text-black col-3'>1012485325</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Account Type:</b></div>
                                    <div className=' text-black col-3'>Saving</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>IFSC Code:</b></div>
                                    <div className=' text-black col-3'>1012485325</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Branch Name:</b></div>
                                    <div className=' text-black col-3'>TIRUPATI</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Pan Card:</b></div>
                                    <div className=' text-black col-3'>BAVPL8983P</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="items-2 product-table">
                        <thead className=' text-black'>
                            <tr>
                                <th className=' text-black'>Sl.<br />No</th>
                                <th className="desc text-black">Description</th>
                                <th className=' text-black'>Net<br />Amount</th>
                                <th className=' text-black'>Payout<br />Charge</th>
                                <th className=' text-black'>GST</th>
                                <th className=' text-black'>Tax<br />Amount</th>
                                <th className=' text-black'>Total<br />Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="product-row">
                                <td className="center text-black">1</td>
                                <td className=' text-black'>Referral Incentive
                                </td>
                                <td className=' text-black'>₹1000.00</td>
                                <td className=' text-black'>₹50.00</td>
                                <td className=' text-black'>18%</td>
                                <td className=' text-black'>₹53.24</td>
                                <td className=' text-black'>₹892.00</td>
                            </tr>
                            <tr className="total-row">
                                <td colSpan={5} className=' text-black'><b>TOTAL:</b></td>
                                <td className=' text-black'><b>₹53.24</b></td>
                                <td className=' text-black'><b>₹892.00</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="words">
                        <b className=' text-black'>Amount in Words:</b><br />
                        <strong className=' text-black'>Eight hundred ninety two only</strong>
                    </div>
                    <div className="sign-box">
                        <div className="sign-content text-black">
                            <b>For SWORLD SOLUTIONS PVT LTD:</b>
                            <div className="signature scribble">D.Suraj Ahmed</div>
                            <strong>Authorized Signatory</strong>
                        </div>
                    </div>
                    <div className="reverse text-black">Sworld Solutions Private Limited</div>
                    <div className="reverse text-black">contact@salar.in</div>
                </section>
            </div>
        </>
    )
}

export default SellRefPayInvoice